import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

// Components
import ProtectedRoute from './components/ProtectedRoute';

// Layouts
import AdminLayout from './layouts/AdminLayout';
import WebviewLayout from './layouts/WebviewLayout';

// Auth Pages
import Login from './pages/Login';

// Admin Pages
import Dashboard from './pages/admin/Dashboard';
import MemberList from './pages/admin/MemberList';
import MemberDetail from './pages/admin/MemberDetail';
import MemberBatteryList from './pages/admin/MemberBatteryList';
import MemberBatteryDetail from './pages/admin/MemberBatteryDetail';
import NoticeList from './pages/admin/NoticeList';
import NoticeDetail from './pages/admin/NoticeDetail';
import AdverList from './pages/admin/AdverList';
import AdverDetail from './pages/admin/AdverDetail';
import HelpList from './pages/admin/HelpList';
import MarketList from './pages/admin/MarketList';
import PopupList from './pages/admin/PopupList';
import PopupDetail from './pages/admin/PopupDetail';
import BlacklistLogList from './pages/admin/BlacklistLogList';
import BlacklistRuleList from './pages/admin/BlacklistRuleList';

// Webview Pages
import Home from './pages/webview/Home';
import Market from './pages/webview/Market';
import AdverView from './pages/webview/AdverView';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <Routes>
          {/* Public Routes */}
          <Route path="/login" element={<Login />} />

          {/* Protected Admin Routes */}
          <Route
            path="/admin"
            element={
              <ProtectedRoute>
                <AdminLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<Dashboard />} />
            <Route path="member" element={<MemberList />} />
            <Route path="member/battery" element={<MemberBatteryList />} />
            <Route path="member/battery/:address" element={<MemberBatteryDetail />} />
            <Route path="member/:id" element={<MemberDetail />} />
            <Route path="notice" element={<NoticeList />} />
            <Route path="notice/:id" element={<NoticeDetail />} />
            <Route path="adver" element={<AdverList />} />
            <Route path="adver/:id" element={<AdverDetail />} />
            <Route path="help" element={<HelpList />} />
            <Route path="market" element={<MarketList />} />
            <Route path="popup" element={<PopupList />} />
            <Route path="popup/:id" element={<PopupDetail />} />
            <Route path="blacklist-logs" element={<BlacklistLogList />} />
            <Route path="blacklist-rules" element={<BlacklistRuleList />} />
          </Route>

          {/* Webview Routes */}
          <Route path="/view" element={<WebviewLayout />}>
            <Route path="home" element={<Home />} />
            <Route path="market" element={<Market />} />
            <Route path="adver" element={<AdverView />} />
          </Route>

          {/* Default redirect to admin */}
          <Route path="/" element={<Navigate to="/admin" replace />} />

          {/* Catch all - redirect to admin */}
          <Route path="*" element={<Navigate to="/admin" replace />} />
        </Routes>
      </BrowserRouter>
    </QueryClientProvider>
  );
}

export default App;
